import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d98c80d3: FaireBrandEntity = {
  token: "b_d98c80d3",
  type: "brand",
  name: "INK MEETS PAPER",
  avatarUrl:
    "https://cdn.faire.com/fastly/5917d0450914daba4881a16d39c9d3d893f61678835d5888511ab4d1acf7417d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6eef6df4238a65d02d9047d78cd7545cb5f6d8a17ac9e9e3c878d2c3ad1199eb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5917d0450914daba4881a16d39c9d3d893f61678835d5888511ab4d1acf7417d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6eef6df4238a65d02d9047d78cd7545cb5f6d8a17ac9e9e3c878d2c3ad1199eb.jpeg",
  location: "Greenville, SC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 65,
  isTopShop: true,
  isInsider: true,
  description:
    "Creatives and makers at heart, we’re Allison and Jamie Nadeau, the owners of INK MEETS PAPER. We believe handwritten communication is one of the most authentic interactions you can share with someone, and we’re passionate about producing thoughtful, deliberate products that help to spread more love in the world. \n\nWe started letterpress printing in 2008 and never looked back. Since then we’ve designed, printed, and shipped hundreds of thousands of cards from our sunny South Carolina studio, and we’re constantly humbled that people choose our products to share love. Thank you for being part of our journey and for making the world a bit more human, one card at a time.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:32.552Z",
    importedBy: "entity-db-cli",
  },
};
